export default __webpack_public_path__ + "static/media/logo-trusted-shops.3479b32c.svg";